
import { Product } from "@/types/product";

export const dido: Product = {
  id: "DIDO-X4",
  groupId: "converters-scalers",
  name: "DIDO X4",
  description: "The DIDO X4 is one of the most advanced 4x4 scaler on the market. The input card slot has a pre-installed 4 input HDMI card with future cards to come addressing various needs. These inputs can be routed to any of the four HDMI outputs with a quad scaler processor and advanced features. These features consist of contrast edge blending for side-by-side projectors (2 Outputs), 1 degree image rotation for portrait and jigsaw puzzle mode videowalls (1-2 Outputs), chroma keying for overlaying of sources on top of others, and pattern generation for signal integrity diagnosing. In addition, the DIDO X4 can seamlessly switch and window 4 sources any size anywhere on the display. Another amazing feature is the built-in USB 3.1 capture output for a PC making interfacing to Zoom Rooms, Teams, etc. even easier.\n\nControl can be sent to the 1G Ethernet port which also has built-in webpage setup support.\n\nChoice is important. That's why the DIDO X4 is the ultimate 4x4 video processor product on the market today.\n\nBenefits\nThe DIDO X4 is many devices in one product providing not just the ultimate experience but the ultimate value.\n\nHere is why: \n\nVideo Effects Processor (Contrast Edge Blending (2 Outputs), Chroma Keying, Image Rotation, Bitmap OSD)\nWindowing up to 4 sources locally to any of the 4 outputs\nVideo wall Processor with 1 Degree Image Rotation (1-2 Outputs)\nDante/AES67 Option\nPattern Generator\nUSB3.1 Capture Output for a Computer (Zoom Room, Teams, WebEx, etc.)",
  features: [
    "Video Wall Capability",
    "Image Rotation (1 Output 1 Deg or 2 Outputs 90 Deg Increments)",
    "Edge Blending (2 Outputs)",
    "Chroma Keying",
    "Built-in Pattern Generator",
    "Bitmap & Character Based OSD for Inputs and Output Channels",
    "Windowing/Multi-viewer",
    "Four HDMI Outputs with Independent Scaling",
    "Seamless Switching",
    "Audio Processing",
    "10/100/1000Mbps LAN PoE+ (PD)",
    "Input Boards (4 HDMI)",
    "Line In/Out Stereo",
    "RS-232 Serial Port and IR (Bidirectional)",
    "Integrated Web Server for Custom Control Pages",
    "Dante®/AES67 IP 2Ch Audio (Optional)",
    "Front Keypad with OLED Display",
    "Auto Sense Switching",
    "Rack and Under Table Mounting"
  ],
  specifications: [
    "Technical",
    "Video Inputs: Four HDMI 2.0 (ICS-H4 Input Card)",
    "HDMI Outputs: Four HDMI 2.0",
    "Analog Audio: Stereo Line In/Out",
    "1G LAN: RJ-45 10/100/1000M PoE",
    "USB: USB 3.1 Type B (4K30 4:4:4 Max Resolution)",
    "Video Bandwidth: 600MHz",
    "Video Support: Up to 4K2K 4:4:4 @60Hz",
    "Audio Support: Up to 32 channels & Break-away Capable",
    "RS-232: Up to 115k Baud",
    "IR: 30KHz-60KHz",
    "Expansion Ports: Dante®/AES67",
    "Interface: IR or Keypad for OSD and OLED, Webserver",
    "Scaler",
    "Bandwidth: 4K60 4:4:4",
    "Scaling Processors: Quad Scaler Processors",
    "Effects: Image Rotation, Videowall, Windowing, OSD, Edge Blending, Chroma Keying",
    "Pattern Generator: Color Bar, Moving Pattern, Hash, & More",
    "Mechanical",
    "Housing: Black Aluminum Enclosure",
    "Dimensions [L x W x H]: 10.5\" x 8\" x 1.22\"",
    "Weight: 2lb 4.6oz (1.04kg)",
    "Mounting: Rack mount (optional) and included under table/wall mount",
    "Power Supply: 25 Watts 48VDC or PoE+ (LAN)",
    "Max Power Consumption: 25 Watts",
    "Operating Temperature: 0~40ºC [32~100ºF]",
    "Storage Temperature: -20~60ºC [-4~140ºF]",
    "Relative Humidity: 20~90% RH [no condensation]"
  ],
  images: [
    "/lovable-uploads/d8c5f2b3-f631-4bf8-9c10-1a5c3213b58f.png",
    "/lovable-uploads/1c61f952-030f-4bc9-9489-5bed8d5b76f6.png",
    "/lovable-uploads/6adfc517-453b-4187-b338-a82598332940.png"
  ],
  applicationDiagram: "/lovable-uploads/DIDO-X4_Application_Diagram.png",
  slug: "dido-x4"
};
